<template>
  <div id="AboutKangLin">
    <div class="top-banner">
      <span class="about-label banner-txt-con banner-txt-con-about" :style="{ left: `${left}px` }">{{ $t("aboutkl.label1") }}</span>
      <!-- <img src="@/assets/img/aboutBanner.png" @load="bannerloadEvent" /> -->
    </div>
    <div class="linkBox">
      <div class="link-tab">
        <div @click="tabEvent(0, 'profile',-20)" :class="btnActiveIndex === 0 ? 'link-btn link-btn-active' : 'link-btn'">
          {{ $t('aboutkl.btn1') }}</div>
        <div @click="tabEvent(1, 'swiper',-30)" :class="btnActiveIndex === 1 ? 'link-btn link-btn-active' : 'link-btn'">
          {{ $t('aboutkl.btn2') }}</div>
        <!-- <div @click="tabEvent(2, 'team',-200)" :class="btnActiveIndex === 2 ? 'link-btn link-btn-active' : 'link-btn'">
          {{ $t('aboutkl.btn3') }}</div>
        <div @click="tabEvent(3, 'unit',-50)" :class="btnActiveIndex === 3 ? 'link-btn link-btn-active' : 'link-btn'">
          {{ $t('aboutkl.btn4') }}</div> -->
          <div @click="tabEvent(2, 'unit',-200)" :class="btnActiveIndex === 2 ? 'link-btn link-btn-active' : 'link-btn'">
            {{ $t('aboutkl.btn4') }}</div>
      </div>
    </div>

    <!-- 公司介绍 -->
    <div class="company-profile" id="profile">
      <div class="company-profile-left wow slideInLeft" data-wow-duration="1.5s">
        <div class="title">{{ $t('aboutkl.btn1') }}</div>
        <div class="desc">
          {{ $t('aboutkl.label2') }}<br /><br />
          {{ $t('aboutkl.label3') }}
        </div>
        <div class="imgs">
          <div class="imgs-item">
            <img src="@/assets/img/company-icon1.png" alt="">
            <div class="label">{{ $t('aboutkl.label4') }}</div>
          </div>
          <div class="imgs-item">
            <img src="@/assets/img/company-icon2.png" alt="">
            <div class="label">{{ $t('aboutkl.label5') }}</div>
          </div>
          <div class="imgs-item">
            <img src="@/assets/img/company-icon3.png" alt="">
            <div class="label">{{ $t('aboutkl.label6') }}</div>
          </div>
        </div>
      </div>
      <div class="company-profile-right wow slideInRight" data-wow-duration="1.5s">
        <img src="@/assets/img/company-img.webp" />
      </div>
    </div>

    <!-- 发展历程 -->
    <div id="swiper" class="container-fuild">
      <!-- <div class="title">{{$t('aboutkl.btn2')}}</div> -->
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
            
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
            <div class="swiper-history-con">
              <div class="swiper-history-title"> {{ $t('aboutkl.btn2') }}</div>
              <div class="swiper-history-year">{{ item.year }}</div>
              <div class="swiper-history-desc" :class="[item.alignType]">
                {{ item.desc }}
                <div class="swiper-history-desc-small">
                  {{ item.desc2 }}
              </div>
            </div>
            </div>
            <div class="swiper-lazy-preloader"></div>

          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination" style="font-size: 20px; color: #fff;"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <!-- 管理团队 -->
    <!-- <div class="management-team " id="team">
      <div class="margin1440 box">
        <div class="title">{{ $t('aboutkl.btn3') }}</div>
        <div class="teams">
          <div class="teams-item" v-for="(item, index) in peopleData" :key="index"  @click.stop="peopleDetail(item, index)">
            <img :src="item.img"  />
            <div class="detail">
              <div class="name">{{ $t(item.name) }}</div>
              <div class="line"></div>
              
              <div class="job" v-if="index==3">{{ $t(item.title1) }}</div>
              <div class="job" v-else>{{ $t(item.title) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 合作单位 -->
    <div class="cooperative-unit" id="unit">
      <div class="margin1440 box">
        <div class="title">{{ $t('aboutkl.btn4') }}</div>
        <div class="unit-imgs">
          <img src="@/assets/img/unit1.png" />
          <img src="@/assets/img/unit2.png" />
          <img src="@/assets/img/unit3.png" />
          <img src="@/assets/img/unit4.png" />
          <img src="@/assets/img/unit5.png" />
          <img src="@/assets/img/unit6.png" />
          <img src="@/assets/img/unit7.png" />
          <img src="@/assets/img/unit8.png" />
          <img src="@/assets/img/unit9.png" />
        </div>
      </div>
    </div>

    <CatDialog width="880px" top="100px" :visible.sync="dialogvisible0">
      <div class="page dialogvisible">
        <div class="container" style="background: none;">
          <div class="body">
            <div class="item-long-wrapper">
              <img class="item-long" :src="selectData.img" />
            </div>
            <div class="group">
              <div class="nick-name"><div class="my-label1">{{ $t(selectData.name) }} </div><div class="my-label2"  :style="{marginTop:(!isEn? '10px': '7px')}">{{ $t(selectData.title) }}
                  {{ $t(selectData.title1) }}</div> </div>
             
              <span class="info"><div class="circle-item-0" />{{$t('about-team1-exp1-t1')}}：</span>
              <div class="view">
                <span class="timer">1989 - 2003</span>
                <span class="organization">{{$t('about-team1-exp1')}}</span>
              </div>
              <div class="view">
                <span class="timer">2003 - 2005</span>
                <span class="organization">{{$t('about-team1-exp2')}}</span>
              </div>
              <div class="view">
                <span class="timer">2005 - 2008</span>
                <span class="organization">{{$t('about-team1-exp3')}}</span>
              </div>
              <div class="view">
                <span class="timer">2009 - 2015</span>
                <span class="organization">{{$t('about-team1-exp4')}}</span>
              </div>

              <div class="view">
                <span class="timer">2015 - 2018</span>
                <span class="organization">{{$t('about-team1-exp5')}}</span>
              </div>
              <div class="view">
                <span class="timer">2018 - 2020 </span>
                <span class="organization">{{$t('about-team1-exp6')}}</span>
              </div>

              <div class="view">
                <span class="timer">2020 - <span v-if="!isEn">至今</span><span v-else>Now</span></span>
                <span class="organization last">{{$t('about-team1-exp7')}}</span>
              </div>
             
              <span class="location" v-if="!isEn"> <div class="circle-item-0" />
                以负责人（PI）身份获得<span class="peoplecolor">6项美国NIH基金、1项美国NSF基金</span>
              
            </span>
            <span class="location" v-if="!isEn"> <div class="circle-item-0" />
               
              
              主持和参与了<span class="peoplecolor">1项国家科技重大专项项目和1项省重点研发项目</span>
            </span>

              <span class="location" v-if="isEn">
                <div class="circle-item-0" />
                As Principle Investigator (PI), he obtained US NIH funding for <span class="peoplecolor">6 projects and US NSF funding for 1 project.</span>
              </span>
              <span class="location" v-if="isEn"> <div class="circle-item-0" />
              
                Leading 1 Major National Science and Technology Special Project and <span class="peoplecolor">1 Key Research and Development Project of Zhejiang province.</span>
             </span>
              <span class="detail-2"><div class="circle-item-0" />{{$t('about-team1-exp1-t3')}}</span>
              <div class="desc-2"> <div class="circle-item-0" />{{$t('about-team1-exp1-t2-1')}}<span class="peoplecolor">{{$t('about-team1-exp1-t2-2')}}</span></div>
             
             <!-- <div class="location-new">
              <div class="circle-item-0"></div>
              {{$t('about-team1-exp1-t4-1')}}
             </div>
             <div class="location-new">
              <div class="circle-item-0"></div>
              {{$t('about-team1-exp1-t4-2')}}
             </div>
              -->


            </div>
          </div>
        </div>
      </div>
    </CatDialog>

    <CatDialog width="880px" top="100px" :visible.sync="dialogvisible1">
      <div class="page dialogvisible1 dialogvisible">
        <div class="container" style="background: none;">
          <div class="body">
            <div class="item-long-wrapper">
              <img class="item-long" :src="selectData.img" />
            </div>
            <!-- <div class="group" v-if="!isEn">
              <div class="nick-name"><div class="my-label1">{{ $t(selectData.name) }} </div><div class="my-label2">{{ $t(selectData.title) }}
                  {{ $t(selectData.title1) }}</div> </div>
                <span class="location "><div class="circle-item-0" /> {{$t('about-team2-exp1-t1-1')}}<span class="peoplecolor">{{$t('about-team2-exp1-t1-2')}}</span>
                </span>

                <span class="location "><div class="circle-item-0" /> {{$t('about-team2-exp1-t2')}}</span>
                <span
                  class="location "> <div class="circle-item-0" />{{$t('about-team2-exp1-t3')}}</span>
              </div> -->


              <div class="group" >
              <div class="nick-name"><div class="my-label1">{{ $t(selectData.name) }} </div><div class="my-label2">{{ $t(selectData.title) }}
                  {{ $t(selectData.title1) }}</div> </div>
                <span class="location "><div class="circle-item-0" /> {{$t('about-team2-exp1-t1-1')}}</span>
                <span class="location "><div class="circle-item-0" />{{$t('about-team2-exp1-t1-2')}}</span>
                <span class="location "><div class="circle-item-0" />{{$t('about-team2-exp1-t1-3')}}</span>
                

                <span class="location "><div class="circle-item-0" /> {{$t('about-team2-exp1-t2')}}</span>
                <span
                  class="location "> <div class="circle-item-0" />{{$t('about-team2-exp1-t3')}}</span>
                  <span
                  class="location "> <div class="circle-item-0" />{{$t('about-team2-exp1-t4')}}</span>
                  <span
                  class="location "> <div class="circle-item-0" />{{$t('about-team2-exp1-t5')}}</span>
              </div>

          </div>

        </div>
      </div>
    </CatDialog>

    <CatDialog width="880px" top="100px" :visible.sync="dialogvisible2">
      <div class="page dialogvisible2 dialogvisible">
        <div class="container" style="background: none;">
          <div class="body">
            <div class="item-long-wrapper">
              <img class="item-long" :src="selectData.img" />
            </div>
            <div class="group">
              <div class="nick-name"><div class="my-label1">{{ $t(selectData.name) }} </div><div class="my-label2">{{ $t(selectData.title) }}
                  {{ $t(selectData.title1) }}</div> </div>
           
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t1')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t2')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t3')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t4')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t5')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t6')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t7')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team3-exp1-t8')}}</span>
            </div>
          </div>
          
        </div>
      </div>
    </CatDialog>
    <CatDialog width="880px" top="100px" :visible.sync="dialogvisible3">
      <div class="page dialogvisible3 dialogvisible">
        <div class="container" style="background: none;">
          <div class="body">
            <div class="item-long-wrapper">
              <img class="item-long" :src="selectData.img" />
            </div>
            <div class="group">
              <div class="nick-name"><div class="my-label1">{{ $t(selectData.name) }} </div><div class="my-label2">
                  {{ $t(selectData.title1) }}</div> </div>
           
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t1')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t2')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t3')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t4')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t5')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t6')}}</span>
              <span class="info"><div class="circle-item-0" />{{$t('about-team4-exp1-t7')}}</span>
            </div>
          </div>
          
        </div>
      </div>
    </CatDialog>
  </div>
</template>

<script>
import Swiper from "swiper";
// import {CatDialog} from "../components/Dialog.vue"
import { menuFixed } from '@/utils/index'
import { WOW } from 'wowjs';

export default {
  name: 'AboutKangLin',
  comments: {
    // CatDialog
  },

  data () {
    return {
      dialogvisible0: false,
      dialogvisible1: false,
      dialogvisible2: false,
      dialogvisible3: false,
      btnActiveIndex: 0,
      isEn: localStorage.getItem("lang") === 'EN',
      peopleData: [
        {
          name: 'about-team1-txt1',
          title: 'about-team1-txt2',
          img: require('@/assets/img/person1.png'),
          title1: 'about-team1-txt4'
        }, {
          name: 'about-team2-txt1',
          title: 'about-team2-txt3',
          title1: 'about-team2-txt4',
          img: require('@/assets/img/person2.png')
        }, {
          name: 'about-team3-txt1',
          title: 'CTO',
          img: require('@/assets/img/persion3.png'),
          title1: 'about-team3-txt4'
        }, {
          name: 'about-team4-txt1',
          title: '医学副总裁',
          img: require('@/assets/img/persion4.png'),
          title1: 'about-team4-txt4'
        }
      ],
      swiperList0: [
        {
          img: require("@/assets/img/20151.jpg"),
          year:'2015',
          desc:'公司成立',
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20171.jpg"),
          year:'2017',
          desc:'“艾滋病的功能治愈“获得国家科技重大专项支持',
          desc2:'（1076万 RMB）',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20181.jpg"),
          year:'2018',
          desc:'艾滋病临床试验开启',
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20191.jpg"),
          year:'2019',
          desc:'完成GMP体系建设获得省重点研发项目支持',
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20201.jpg"),
          year:'2020',
          desc:'AAV昆虫杆状病毒生产系统获得数量级提高',
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20211.jpg"),
          year:'2021',
          desc:`帕金森病项目在动物实验中达到治愈性效果`,
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20221.jpg"),
          year:'2022',
          desc:'地中海贫血项目IIT结果优异证实平台技术能力',
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20231.jpg"),
          year:'2023',
          desc:'国家级专精特新小巨人 KL003地中海贫血项目入选浙江省尖兵计划',
          desc2:'',
          alignType: 'type2'
        },
      ],
      swiperList1: [
      {
          img: require("@/assets/img/20151.jpg"),
          year:'2015',
          desc:'Kanglin Biotec (Hangzhou) Co., Ltd. is founded',
          desc2:'',
          alignType: 'type2'
        },
        {
          img: require("@/assets/img/20171.jpg"),
          year:'2017',
          desc:' “Functional Cure for AIDS” receives support from the National Science and Technology Major Project',
          desc2:'(10.76 million RMB)',
          alignType: ''
        },
        {
          img: require("@/assets/img/20181.jpg"),
          year:'2018',
          desc:'Clinical trial for the AIDS project begins',
          desc2:'',
          alignType: ''
        },
        {
          img: require("@/assets/img/20191.jpg"),
          year:'2019',
          desc:'GMP system is completed and support from the Key Research and Development Projects of Zhejiang Province',
          desc2:'',
          alignType: ''
        },
        {
          img: require("@/assets/img/20201.jpg"),
          year:'2020',
          desc:'Breakthrough in the insect-cell baculovirus AAV production system',
          desc2:'',
          alignType: ''
        },
        {
          img: require("@/assets/img/20211.jpg"),
          year:'2021',
          desc:`Parkinson’s disease candidate demonstrates therapeutic effect in animal studies`,
          desc2:'',
          alignType: ''
        },
        {
          img: require("@/assets/img/20221.jpg"),
          year:'2022',
          desc:'IIT results of the β-thalassemia candidate demonstrate best-in-class potential',
          desc2:'',
          alignType: ''
        },
        {
          img: require("@/assets/img/20231.jpg"),
          year:'2023',
          desc:"National level specialized and innovative little giant KL003 Mediterranean anemia project selected for Zhejiang Province's elite program",
          desc2:"",
          alignType: ''
        },
      ],
      left: '',
      selectData: {}
    }
  },
  computed:{
    swiperList(){
      return localStorage.getItem("lang") === 'EN' ? this.swiperList1 : this.swiperList0
    }
  },
  methods: {
    bannerloadEvent () {
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74 - $('.top-banner').offset().left
    },
    tabEvent (index, id,num = 0) {
      this.btnActiveIndex = index
      let isfixed = $('.linkBox').css('position') === 'fixed'
      let offset = index == 0 && isfixed ? 65 : 0
      if(!isfixed && index!==0){
        offset -= 65
      }
      const top = $('#' + id).offset().top - 134 + offset - num
      $("html,body").animate({ scrollTop: top }, 500);
    },
    peopleDetail (data, index) {
      this.selectData = data
      let dialogvisible = 'dialogvisible' + index
      this[dialogvisible] = true
    },
     onScrollSwitchTabAbout(){
      var that = this
      window.addEventListener('scroll', function () {
        // var tarElArr = [$("#profile"), $("#swiper"), $("#team"), $("#unit")]
        // var tarElScrollArr = [tarElArr[0].offset().top - 110, 
        // tarElArr[1].offset().top - 110,
        //  tarElArr[2].offset().top - 110,
        //  tarElArr[3].offset().top -150
        // ] 
        // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        // console.log(scrollTop)
        // if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
        //   that.btnActiveIndex = 0

        // }
        // else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
        //   that.btnActiveIndex = 0
        // } else if (tarElScrollArr[1] < scrollTop && scrollTop <= tarElScrollArr[2]) {
        //   that.btnActiveIndex = 1
        // }
        // else if (tarElScrollArr[2] < scrollTop && scrollTop <= tarElScrollArr[3]) {
        //   that.btnActiveIndex = 2
        // }
        // else {
        //   that.btnActiveIndex = 3
        // }
        var tarElArr = [$("#profile"), $("#swiper"),  $("#unit")]
        var tarElScrollArr = [tarElArr[0].offset().top - 110, 
        tarElArr[1].offset().top - 110,
         tarElArr[2].offset().top -150
        ] 
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        console.log(scrollTop)
        if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
          that.btnActiveIndex = 0

        }
        else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
          that.btnActiveIndex = 0
        } else if (tarElScrollArr[1] < scrollTop && scrollTop <= tarElScrollArr[2]) {
          that.btnActiveIndex = 1
        }
        
        else {
          that.btnActiveIndex = 2
        }
        console.log('this.btnActiveIndex'+ that.btnActiveIndex)
    })
    },
  },

  mounted () {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      // autoplay: {
      //   delay: 3000,
      //   stopOnLastSlide: false,
      //   disableOnInteraction: false
      // },
      autoplay: false,
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return `<span class='${currentClass}' style="font-size: 30px; color: #fff;" ></span>/<span class='${totalClass}'>/</span>`
        },
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    
    menuFixed()

    this.$nextTick(() => {
      new WOW().init();
    })
    setTimeout(() => {
      this.bannerloadEvent()
      this.onScrollSwitchTabAbout()
    }, 100)
  }
}
</script>

<style lang="less" scoped>

.location-new {
  color: rgba(61, 61, 61, 1);
  font-size: 16px;
  line-height: 28px;
  // align-self: flex-end;
 
  margin: 12px 44px 0 20px;
  font-weight: bold;position: relative;
}

#AboutKangLin {
  width: 100%;
  .top-banner{
      width: 100%;
      background: url(../../assets/img/webp/aboutBanner.webp) no-repeat top;
      background-size: cover;
  }

  .peoplecolor {
    color: #2DB3D0;
  }

  .dialogvisible1 {
    .location {
      height: auto;
      position: relative;
      // background:#2db3d0 url(../../assets/img/yuan.png) no-repeat left center;
      // background-size:20px 20px;
    }

    .one {
      // top: -166px
    }

    .two {
      // top: -150px
    }

    .three {
      // top: -132px
    }

    .circle-item-1 {
      top: 49px;
    }

    .circle-item-1.two {
      top: 118px;
    }

    .circle-item-1.three {
      top: 242px;
    }

    .group {
      height: auto;
    }

    .article {
      position: relative;
      top: -100px;
      margin: 0px 51px 0 0;
    }

    .container {
      // padding: 40px 12px 0 12px;
    }
  }

  .dialogvisible2 {
    span.info{
      margin: 12px 44px 0 20px !important
    }
    .desc-2 {
      margin: 16px 0 0 20px;
    }

    .circle {
      bottom: 73px;
      top: 116px
    }

    .circle-1.one {
      bottom: 394px;
    }
    .circle-1.two {
      bottom: 327px;
    }
    .circle-1.three {
      bottom: 258px;
    }
    .circle-1.four {
      bottom: 192px;
    }
    .circle-1.five {
      bottom: 94px
    }

    .article {
      position: relative;
      top: -100px;
      padding-left: 26px
    }

    .container {
      // padding: 40px 12px 0 12px;
    }
  }


  .top-banner {
    position: relative;

    img {
      width: 100%;
      max-height: 650px;
    }

    .about-label {
      position: absolute;
      left: 82px;
      line-height: 74px;
      font-size: 60px;
      color: #ffffff;
    }
  }

  .company-profile {
    display: flex;
    background-color: #fff;
    padding: 0px 80px;
    align-items: center;
    width: 1440px;
    margin: 0 auto;

    .company-profile-left {
      padding: 120px 0px;
      padding-right: 130px;
      flex: 1;

      .title {
        font-size: 40px;
        color: #000000;
        margin-bottom: 48px;
      }

      .desc {
        font-size: 16px;
        color: #000000;
      }

      .imgs {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .imgs-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 60px;

          img {
            width: 64px;
            height: 64px;
            margin-bottom: 16px;
          }

          .label {
            font-size: 14px;
            background: linear-gradient(270deg, #06488d 0%, #00dadc 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }

    .company-profile-right {
      width: 605px;
      height: 100%;

      img {
        width: 100%;
        height: auto;
      }
    }
  }

  .management-team {
    background-color: #f8f8f8;

    .box {
      height: 960px;
      padding: 120px 82px;
    }

    .title {
      font-size: 40px;
      color: #000000;
      margin-bottom: 60px;
    }

    .teams {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .teams-item {
        display: flex;
        // width: 412px;
        width: 405px;
        height: 338px;
        padding: 40px 32px;
        padding-right: 10px;
        margin-right: 20px;
        background-image: url("../../assets/img/team-bg.png");
        background-repeat: no-repeat;
        background-size: 412px 338px;
        background-position: center;
        cursor: pointer;
       margin-bottom: 20px;
        img {
          width: 196px;
          height: 258px;
    //       width: 165px;
    // height: 223px;
          border-radius: 20px;
        }

        .detail {
          padding-left: 24px;
          padding-top: 40px;

          .name {
            font-size: 20px;
            color: #2db3d0;
          }

          .line {
            width: 40px;
            border-bottom: 1px solid #2db3d0;
            margin: 16px 0px;
          }
        }
      }
    }
  }

  .cooperative-unit {
    background-image: url("../../assets/img/coop-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;

    .box {
      height: 1123px;
      padding: 120px;
    }

    .title {
      font-size: 40px;
      color: #ffffff;
      margin-bottom: 138px;
    }

    .unit-imgs {
      display: grid;
      grid-template-columns: 318px 318px 318px;
      grid-template-rows: 130px 130px 130px;
      grid-gap: 120px;

      img {
        width: 318px;
        height: 130px;
      }
    }
  }

  #swiper {
    height: 810px;
    position: relative;
    width: 1440px;
    margin: 0 auto;

    .title {
      position: absolute;
      top: 120px;
      left: 80px;
      font-size: 40px;
      color: #ffffff;
      z-index: 100;
    }
  }

  #swiper .banner-swiper {
    width: 100%;
    height: 100%;
  }

  #swiper .banner-swiper .swiper-slide img {
    width: 100%;
    height: 100%;
  }

  #swiper .banner-swiper .swiper-slide {
    position: relative;
  }

  #swiper .banner-swiper .swiper-slide-title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999999;
    width: 100%;
    height: 100%;
    color: #fff;
    background: rgba(51, 51, 51, 0.534);
    text-align: center;
    line-height: 80px;
  }

  #swiper .banner-swiper .swiper-slide-title>h1 {
    font-size: 50px;
    margin-top: 12%;
  }

  #swiper .banner-swiper .swiper-slide-title>p {
    font-size: 20px;
    margin-top: 1%;
    font-weight: 700;
  }

  #swiper .swiper-button-prev {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/img/btn-prev.png");
    background-size: 60px;
    top: 60%;
  }

  #swiper .swiper-button-next {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/img/btn-next.png");
    background-size: 60px;
    top: 60%;
  }
}


</style>

<style src="./index.css" scoped>
;



// WEBPACK FOOTER //
// src/view/AboutKangLin/index.vue